import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useCart } from './CartContext';
import { bookProducts } from './bookData';
import AddToCartNotification from './AddToCartNotification';
import './App.css';

function BookDetail() {
  const { bookKey } = useParams();
  const { addToCart } = useCart();
  const book = bookProducts.find((item) => item.key === bookKey);
  const gallery = book?.gallery || [];
  const [selectedImage, setSelectedImage] = useState(book?.img);

  useEffect(() => {
    setSelectedImage(book?.img);
  }, [book]);

  if (!book) {
    return (
      <div className="main-bg">
        <AddToCartNotification />
        <div className="book-detail-page">
          <h2>Book Not Found</h2>
          <p>The book you are trying to view does not exist.</p>
          <Link to="/books" className="home-books-cta">
            Back to Books
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="main-bg">
      <AddToCartNotification />
      <div className="book-detail-page">
        <Link to="/books" className="home-books-cta book-detail-back">
          ← Back to Books
        </Link>
        <div className="book-detail-card">
          <div className="book-detail-image-wrapper">
            <img src={selectedImage || book.img} alt={book.title} className="book-detail-img" />
            {gallery.length > 0 && (
              <div className="book-gallery-thumbs">
                {[book.img, ...gallery].map((thumb) => (
                  <button
                    type="button"
                    key={thumb}
                    className={`book-gallery-thumb ${selectedImage === thumb ? 'active' : ''}`}
                    onClick={() => setSelectedImage(thumb)}
                  >
                    <img src={thumb} alt={`${book.title} preview`} />
                  </button>
                ))}
              </div>
            )}
          </div>
          <div className="book-detail-copy">
            <h2>{book.title}</h2>
            <p className="book-type">Physical Copy</p>
            <p className="book-price">${book.price}</p>
            <p className="book-description">{book.description}</p>
            <ul className="book-detail-list">
              {book.highlights.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          {gallery.length > 0 && (
            <div className="book-gallery">
              <h4>Gallery</h4>
              <div className="book-gallery-grid">
                {gallery.map((src) => (
                  <img key={src} src={src} alt={`${book.title} gallery`} />
                ))}
              </div>
            </div>
          )}
            <button
              className="book-btn"
              onClick={() => {
                addToCart(book);
              }}
            >
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookDetail;
